<template>
	<div class="brick">
		<div class="list_top_box">
			<div class="left_option">
				<p class="mgb_5">
					<span class="int_type mgr_5">
						<select id="dlActive" v-model="active_yn" @change="gotoPage(1)">
							<option v-for="tag in this.$activeTags" v-bind:value="tag.value" v-bind:key="tag.value">{{ tag.text }}</option>
						</select>
					</span>

					<span v-show="!this.initial_partner_type" class="int_type mgr_10">
						<select v-model="partner_type" @change="gotoPage(1)" :disabled="user.customer_only_view">
							<option value="A">All Type</option>
							<option value="C">Customer</option>
							<option value="V">Vendor</option>
							<option value="B">Both</option>
						</select>
					</span>

					<em class="lt_text">Reg.Date</em>
					<span class="mgr_5"> <CustomDatePicker v-model="crt_date_from"/> ~ <CustomDatePicker v-model="crt_date_to"/></span>

					<em class="lt_text">Grade</em>
					<span class="int_type_no_border mgr_5"> <CodeSelect :width="60" :showDesc="false" :codes="grades" v-model="grade" /> </span>

					<!--					<em class="lt_text">Country</em>-->
					<!--					<span class="int_type_no_border mgr_5">-->
					<!--						<CodeSelect :width="60" :showDesc="false" :codes="countries" v-model="country" @post-loading="postCoutryLoading" />-->
					<!--					</span>-->

					<country-select :countries="countries" :bool="true" v-model="country" />

					<em class="lt_text">State</em>
					<span class="int_type_no_border mgr_5"> <CodeSelect :width="60" :codeWidth="120" :showDesc="false" :codes="filteredStates" v-model="state" /> </span>

					<template v-if="user.company_id == 'newjigu'">
						<em class="lt_text">Territory</em>
						<span class="int_type_no_border mgr_5"> <CodeSelect :width="60" :codeWidth="120" :showDesc="false" :codes="territories" v-model="territory_code" /> </span>
					</template>

					<span v-show="!this.initial_partner_type || this.initial_partner_type == 'C'">
						<em class="lt_text">Sales Group</em>
						<span class="int_type_no_border mgr_5"><CodeSelect className="tbl_select" :codes="salesGroups" :showDesc="false" v-model="sales_group_code" @set-code="setSalesGroup"/></span>
					</span>

					<span v-show="!this.initial_partner_type || this.initial_partner_type == 'C'">
						<em class="lt_text">Salesman</em>
						<span class="int_type_no_border mgr_5"><CodeSelect className="tbl_select" :codes="salesmansForSearch" :showDesc="false" v-model="salesman_id" @set-code="setSalesman"/></span>
					</span>

					<span class="int_type mgr_5" style="width: 120px;">
						<input type="text" v-model="keyword" placeholder="Enter Keyword" autofocus autocomplete="off" @keyup.enter="gotoPage(1)" />
					</span>

					<span v-show="!this.initial_partner_type || this.initial_partner_type == 'C'" class="int_type mgr_15" style="width: 120px;">
						<input type="text" v-model="track_no" placeholder="UPS Tracking No" autofocus autocomplete="off" @keyup.enter="gotoPage(1)" />
					</span>

					<span class="int_type ssm_int">
						<input type="text" class="ssm_int" v-model.trim="from_zip_code" title="From Zip Code" placeholder="Zip Code" autofocus autocomplete="off" @keyup.enter="gotoPage(1)" />
					</span>
					~
					<span class="int_type ssm_int mgr_5">
						<input type="text" class="ssm_int" v-model.trim="to_zip_code" title="To Zip Code" placeholder="Zip Code" autofocus autocomplete="off" @keyup.enter="gotoPage(1)" />
					</span>

					<a href="javascript:void(0);" class="search_bt" @click="gotoPage(1)">Search</a>
					<a href="javascript:void(0);" class="gray_bt mgr_10" @click="reset()">Reset</a>

					<input v-if="env === 'development'" type="checkbox" v-model="include_balance" />
				</p>
			</div>
		</div>

		<partnerTable :company_id="company_id" :partners="partners" @sort="sort" :sort_key="sort_key" :sort_direction="sort_direction" @memo="memo" @arHistory="gotoArHistory" />

		<div style="text-align:right;padding-right:10px;">Total Count : {{ list_count | commaSeparated }}</div>

		<Paging ref="paging" v-on:gotoPage="gotoPage"></Paging>
		<div class="fl_r int_type mgr_15">
			<select v-model="page_size" @change="search">
				<option value="25">25 per page</option>
				<option value="50">50 per page</option>
				<option value="100">100 per page</option>
				<option value="200">200 per page</option>
			</select>
		</div>

		<div class="bottom_bt_box">
			<ul class="fl_l mgr_15">
				<li v-if="user.company_id != 'newjigu' || modifiable"><a href="javascript:void(0)" @click="customersWithNoRecentSalesShow">Customers With No Recent Sales</a></li>
			</ul>
			<ul>
				<li><a href="javascript:void(0)" @click="confirmCustomerStatement('bill_to_code')">Bill To Customer Statement</a></li>
			</ul>
			<ul>
				<li><a href="javascript:void(0)" @click="confirmCustomerStatement('ship_to_code')">Ship To Customer Statement</a></li>
			</ul>
			<ul>
				<li v-if="modifiable">
					<router-link :to="{ name: 'partnerDetail', params: { mode: 'add', initial_partner_type: this.initial_partner_type }, query: { backUri: this.uri } }">Add </router-link>
				</li>
			</ul>
			<ul>
				<li v-if="user.company_id != 'newjigu' || modifiable"><a href="javascript:void(0)" @click="reportPrint">Print</a></li>
			</ul>
			<ul>
				<li v-if="user.company_id != 'newjigu' || modifiable"><a href="javascript:void(0)" @click="reportExcel">Excel</a></li>
			</ul>

			<div v-if="['newjigu'].includes(company_id)" style="clear: both; padding-top: 5px;">
				<label class="right_option mgr_15"><input type="checkbox" v-model="show_credit" /> Show All Credit in Printed Customer Statement.</label>
			</div>
		</div>
		<div class="bottom_bt_box">
			<ul class="fl_l mgr_15" v-if="modifiable">
				<li class="mgr_5" style="padding-top:3px;">
					<label for="apply_to_old_invoices" style="margin-left:5px;"> <input type="checkbox" id="apply_to_old_invoices" v-model="apply_to_old_invoices" />Apply To Old Invoices</label>
				</li>
				<li>
					<span class="int_type_no_border mgr_5"><CodeSelect className="tbl_select" :codes="salesGroups" :showDesc="true" v-model="change_to_sales_group_code"/></span>
				</li>
				<li><a href="javascript:;" @click="changeSalesGroup()">Change Sales Group</a></li>
			</ul>

			<ul class="fl_l mgr_15" v-if="modifiable">
				<li>
					<span class="int_type_no_border mgr_5"><CodeSelect className="tbl_select" :codes="salesmansForChange" :showDesc="true" v-model="change_to_salesman_id"/></span>
				</li>
				<li><a href="javascript:;" @click="changeSalesman()">Change Salesman</a></li>
			</ul>
		</div>

		<Modal @close="closeModal" v-if="showModal && modalName == 'Memo'">
			<!-- default 슬롯 콘텐츠 -->
			<template slot="title">Partner Memo</template>
			<template slot="body">
				<MemoPopup :partner_code="selected_partner_code" v-on:close="closeModal($event)" />
			</template>
		</Modal>

		<CustomerStatementCriteria
			v-if="showModal && modalName == 'customer_statement_criteria'"
			@close="closeModal()"
			:show_credit="show_credit"
			:show_PDC="show_PDC"
			:show_payment="show_payment"
			:init_payment_date="payment_date"
			@change_show_credit="boolean => (show_credit = boolean)"
			@change_show_PDC="boolean => (show_PDC = boolean)"
			@change_show_payment="boolean => (show_payment = boolean)"
			@change_payment_date="date => (payment_date = date)"
			@printStatement="customerStatement()"
		/>

		<customers-without-invoices />
	</div>
</template>

<script>
import { inputSelectOnClick } from '@/utils/etc.js';
import { apiIndex, apiSelectPartnerList, apiUpdatePartnerSalesGroupBatch, apiUpdatePartnerSalesmanBatch } from '@/api/partner/index.js';
import CustomDatePicker from '@/components/common/CustomDatePicker.vue';
import Paging from '@/components/common/Paging';
import CodeSelect from '@/components/common/CodeSelect';
import Modal from '@/components/common/Modal';
import MemoPopup from '@/components/common/MemoPopup';
import CustomerStatementCriteria from '@/components/common/CustomerStatementCriteria.vue';
import { apiGetBase64ReportTemplate, companyMrtUrl, exportDataExcel, objectCopy, objectToFormData, PrintType, Report, reportMrtUrl, reportRender } from '@/api/util';
import { today } from '@/utils/date';
import { apiSelectCustomerStatement } from '@/api/report/report';
import { defaultDataType } from 'export-xlsx';
// import { reorganizeInvAndPay, combineInvAndPDC } from '@/utils/customerStatement.js';
import CustomersWithoutInvoices from '@/views/partner/CustomersWithNoRecentSales';
import PartnerTable from '@/views/partner/PartnerTable';
import CountrySelect from '@/components/common/CountrySelect';

export default {
	data: function() {
		return {
			uri: null,
			backUri: '/',
			paging_yn: 'Y',
			page_size: 25,
			page_no: 1,
			list_count: 0,

			active_yn: 'A',
			partner_type: 'A',
			keyword: null,

			initial_partner_type: null,

			sort_key: 'code',
			sort_direction: 'ASC',

			crt_date_from: null,
			crt_date_to: null,
			track_no: null,

			partners: [],

			grade: '',
			grades: [],
			state: '',
			states: [],
			territory_code: null,
			territories: [],
			country: '',
			countries: [],
			salesGroups: [],
			sales_group_code: null,
			sales_team_code_by_group: null,
			sales_team_code_by_man: null,
			saveParam: {},
			modalName: '',
			showModal: false,
			selected_partner_code: null,
			salesmans: [],
			salesman_id: null,
			to_zip_code: null,
			from_zip_code: null,

			allSelected: false,
			change_to_sales_group_code: null,
			change_to_salesman_id: null,

			apply_to_old_invoices: false,

			include_balance: process.env.NODE_ENV == 'development' ? false : true,

			show_credit: true,
			show_PDC: true,
			show_payment: false,
			customer_statement_type: null,
			payment_date: today(),
		};
	},
	computed: {
		filteredStates: function() {
			if (!this.country && this.user.company_id == 'newjigu') return this.states;

			//return this.states;
			var vm = this;
			var fStates = this.states.filter(s => s.country == vm.country);
			//console.log(fStates.length);
			if (fStates.length == 0) vm.state = null;
			//else vm.state = fStates[0].state;

			return fStates;
			//console.log(this.states.filter(s => s.country == vm.country));
			//return this.states.filter(s => s.country == vm.country);
		},
		modifiable() {
			var menus = this.$session.get('menus');
			//console.log(this.$router.history.current.path);
			var current_path = this.$router.history.current.path;
			if (this.initial_partner_type == 'C') current_path = current_path.replace('partner_main', 'customer_main');
			else if (this.initial_partner_type == 'V') current_path = current_path.replace('partner_main', 'vendor_main');
			for (var i = 0; i < menus.length; i++) {
				// if (menus[i].path == this.$router.history.current.path && menus[i].modify_yn == 'Y') return true;
				if ((menus[i].path == current_path || menus[i].path == current_path.replace('add', 'detail')) && menus[i].modify_yn == 'Y') return true;
			}
			return false;
		},
		user: function() {
			return this.$session.get('user');
		},
		company_id() {
			return this.user ? this.user.company_id : '';
		},

		checkedPartner() {
			return this.partners.filter(partner => partner.selected).map(partner => partner.code);
		},
		salesmansForSearch() {
			return this.salesmans.filter(sm => !this.sales_team_code_by_group || sm.sales_team_code === this.sales_team_code_by_group).map(sm => ({ code: sm.user_id, name: sm.name, sales_team_code: sm.sales_team_code }));
		},
		salesmansForChange() {
			return this.salesmans.map(sm => ({ code: sm.user_id, name: sm.name }));
		},
		env: function() {
			return process.env.NODE_ENV;
		},
		companyIsNewjigu() {
			return this.company_id === 'newjigu';
		},
		selectParam() {
			return {
				active_yn: this.active_yn,
				partner_type: this.partner_type,
				keyword: this.keyword,
				grade: this.grade,
				state: this.state,
				country: this.country,
				territory_code: this.territory_code,
				sales_team_code_by_group: this.sales_team_code_by_group,
				sales_team_code_by_man: this.sales_team_code_by_man,
				sales_group_code: this.sales_group_code,
				salesman_id: this.salesman_id,
				//all_sales_group: true,
				include_in_charge: true,
				from_main: true,
				crt_date_from: this.crt_date_from,
				crt_date_to: this.crt_date_to,
				track_no: this.track_no,
				paging_yn: this.paging_yn,
				page_size: Number(this.page_size),
				page_no: this.page_no,
				start_index: this.page_size * (this.page_no - 1),
				sort_key: this.sort_key,
				sort_direction: this.sort_direction,
				initial_partner_type: this.initial_partner_type,
				from_zip_code: this.from_zip_code,
				to_zip_code: this.to_zip_code,
				//include_balance: this.include_balance,
			};
		},

		defaultCountry: {
			//parameter 에서 country 가 있으면 true 로 리턴
			get() {
				return this.$route.query.country !== undefined;
			},
			set() {},
		},
	},
	components: {
		CountrySelect,
		PartnerTable,
		CustomersWithoutInvoices,
		Paging,
		CodeSelect,
		Modal,
		MemoPopup,
		CustomDatePicker,
		CustomerStatementCriteria,
	},
	methods: {
		async changeSalesGroup() {
			if (this.partners.filter(p => p.selected).length == 0) {
				this.$toast.error('No partner(s) selected.');
				return;
			}

			if (!this.change_to_sales_group_code) {
				this.$toast.error('Sales group not selected.');
				return;
			}

			var msg = 'Are you sure to change sales group of the selected?';
			if (this.apply_to_old_invoices) msg += '\n\nSalesgroup of old invoice(s) will be changed.';

			if (confirm(msg)) {
				var param = { partners: this.partners.filter(p => p.selected), sales_group_code: this.change_to_sales_group_code };
				if (this.apply_to_old_invoices) param.apply_to_old_invoices = true;

				const { data } = await apiUpdatePartnerSalesGroupBatch(param);

				if (data.result) {
					this.$toast.success('Updated successfully');
					this.selectPartners(
						this.pageNo,
						this.partners.filter(p => p.selected),
					);
				} else {
					this.$toast.error('Failed');
				}
			}
		},
		async changeSalesman() {
			if (this.partners.filter(p => p.selected).length == 0) {
				this.$toast.error('No partner(s) selected.');
				return;
			}

			if (!this.change_to_salesman_id) {
				this.$toast.error('Salesman not selected.');
				return;
			}

			if (confirm('Are you sure to change salesman of the selected?')) {
				const { data } = await apiUpdatePartnerSalesmanBatch({ partners: this.partners.filter(p => p.selected), salesman_id: this.change_to_salesman_id });

				if (data.result) {
					this.$toast.success('Updated successfully');
					this.selectPartners(
						this.pageNo,
						this.partners.filter(p => p.selected),
					);
				} else {
					this.$toast.error('Failed');
				}
			}
		},
		setSalesGroup(sg) {
			if (sg) {
				if (sg.sales_team_code !== this.sales_team_code_by_man) {
					this.salesman_id = null;
					this.sales_team_code_by_man = null;
				}

				this.sales_team_code_by_group = sg.sales_team_code;
			} else {
				this.sales_team_code_by_group = null;
			}
		},
		setSalesman(sm) {
			if (sm) this.sales_team_code_by_man = sm.sales_team_code;
			else this.sales_team_code_by_man = null;
		},
		selectAll() {
			//console.log(this.allSelected);
			var vm = this;
			this.partners.forEach(function(partner) {
				partner.selected = vm.allSelected;
			});
		},
		gotoArHistory(partner_code, partner_name) {
			this.$router.push({
				name: 'arHistory',
				query: {
					backUri: this.uri,
					bill_to_code: partner_code,
					bill_to_name: partner_name,
					date_type_is_invoice: '1',
				},
			});
		},
		openModal(modalName) {
			this.modalName = modalName;
			this.showModal = true;
		},
		closeModal(rv) {
			this.showModal = false;
			if (rv) this.selectPartners(this.page_no);
		},
		memo(partner) {
			this.selected_partner_code = partner.code;
			this.openModal('Memo');
		},
		sortMark: function(sort_key) {
			if (this.sort_key == sort_key) return this.sort_direction == 'ASC' ? '▲' : '▼';
			else return null;
		},
		sort(sort_key) {
			if (sort_key == 'no') return;

			if (this.sort_key === sort_key) {
				this.sort_direction = this.sort_direction === 'ASC' ? 'DESC' : 'ASC';
			} else {
				this.sort_key = sort_key;
				if (this.sort_key == 'ytd') this.sort_direction = 'DESC';
				else this.sort_direction = 'ASC';
			}
			this.search();
		},
		reset() {
			this.sort_key = 'code';
			this.sort_direction = 'ASC';

			this.keyword = null;
			this.grade = null;
			this.state = null;
			this.country = 'US';
			this.territory_code = null;
			//this.country = '';
			this.sales_team_code_by_group = null;
			this.sales_team_code_by_man = null;
			this.sales_group_code = null;
			this.salesman_id = null;

			this.crt_date_from = null;
			this.crt_date_to = null;
			this.track_no = null;
			this.from_zip_code = null;
			this.to_zip_code = null;

			this.show_credit = true;
			this.show_PDC = true;
			this.show_payment = false;
			this.customer_statement_type = null;
			this.payment_date = today();
		},
		search() {
			let name;
			if (this.initial_partner_type === 'C') name = 'customers';
			else if (this.initial_partner_type === 'V') name = 'vendors';
			else name = 'partner';

			this.$router.push({ name: name, query: this.selectParam }).catch(() => {});
		},

		findCustomer(list, code) {
			if (list.filter(p => p.code == code).length > 0) return true;
			else return false;
		},
		async selectPartners(pageNo, retain_selected_list) {
			if (pageNo) this.page_no = pageNo;
			else this.page_no = 1;

			let param = this.selectParam;

			if (this.user.company_id == 'newjigu') param.all_sales_group = true;
			if (this.include_balance) param.include_balance = this.include_balance;
			const { data } = await apiSelectPartnerList(param);

			//console.log('....' + this.country + '**');
			// if (this.country) this.$session.set('partner_country', this.country);
			// else this.$session.set('partner_country', '__blank');

			this.saveParam = {
				active_yn: this.active_yn,
				partner_type: this.partner_type,
				keyword: this.keyword,
				grade: this.grade,
				state: this.state,
				country: this.country,
				territory_code: this.territory_code,
				sales_group_code: this.sales_group_code,
				salesman_id: this.salesman_id,
				include_in_charge: true,
				from_main: true,
				crt_date_from: this.crt_date_from,
				crt_date_to: this.crt_date_to,
				track_no: this.track_no,
				sort_key: this.sort_key,
				sort_direction: this.sort_direction,
				from_zip_code: this.from_zip_code,
				to_zip_code: this.to_zip_code,
			};

			var no = 0;
			data.partnerList.forEach(partner => {
				if (partner.ytd == null) partner.ytd = 0;

				partner.no = ++no + (this.page_no - 1) * this.page_size;
			});
			this.partners = data.partnerList;
			this.list_count = data.list_count;

			var vm = this;
			if (retain_selected_list) {
				this.partners.forEach(p => {
					if (vm.findCustomer(retain_selected_list, p.code)) p.selected = true;
				});
			}

			this.$refs.paging.setPage(this.page_no, this.page_size, this.list_count);
		},
		gotoPage(pageNo) {
			if (pageNo) this.page_no = pageNo;
			else this.page_no = 1;

			this.search();
		},
		selectPartner(selectedPartner) {
			this.$router.push({
				name: 'partnerDetail',
				params: { mode: 'detail' },
				query: { backUri: this.uri, code: selectedPartner.code },
			});
		},

		async index() {
			const { data } = await apiIndex();

			this.grades = data.gradeList;
			this.states = data.stateList;
			this.countries = data.countryList;
			this.salesGroups = data.salesGroupList;
			this.salesmans = data.salesmanList;
			this.territories = data.territoryList;
		},
		async init() {
			await this.index();
			this.active_yn = this.companyIsNewjigu ? 'Y' : 'A';
			if (this.user.customer_only_view) this.partner_type = 'C';
			let query = this.$route.query;
			if (query.country === undefined) {
				this.postCoutryLoading();
			} else {
				this.country = query.country;
			}
			if (query.page_size) this.page_size = query.page_size;
			if (query.sort_key) this.sort_key = query.sort_key;
			if (query.sort_direction) this.sort_direction = query.sort_direction;
			if (query.active_yn) this.active_yn = query.active_yn;
			if (query.partner_type) this.partner_type = query.partner_type;
			if (query.grade) this.grade = query.grade;
			if (query.state) this.state = query.state;
			if (query.territory_code) this.territory_code = query.territory_code;
			if (query.country) this.country = query.country;
			if (query.sales_team_code_by_group) this.sales_team_code_by_group = query.sales_team_code_by_group;
			if (query.sales_team_code_by_man) this.sales_team_code_by_man = query.sales_team_code_by_man;
			if (query.sales_group_code) this.sales_group_code = query.sales_group_code;
			if (query.salesman_id) this.salesman_id = query.salesman_id;
			if (query.crt_date_from) this.crt_date_from = query.crt_date_from;
			if (query.crt_date_to) this.crt_date_to = query.crt_date_to;
			if (query.track_no) this.track_no = query.track_no;
			if (query.keyword) this.keyword = query.keyword;
			if (query.from_zip_code) this.from_zip_code = query.from_zip_code;
			if (query.to_zip_code) this.to_zip_code = query.to_zip_code;
			if (query.include_balance) this.include_balance = query.include_balance;

			await this.selectPartners(query.page_no);
		},
		postCoutryLoading() {
			// 	// minkhair는 아직 partner의 country정보가 입력되지 않음. 뉴지구도 디폴트는 전체
			if (['minkhair', 'newjigu'].includes(this.company_id)) return;

			let idx = this.countries.findIndex(c => c.code === 'US');
			if (idx < 0) idx = this.countries.findIndex(c => c.code === 'USA');
			if (idx > -1) this.country = this.countries[idx].code;
		},

		async reportPrint() {
			const { data } = await apiSelectPartnerList(this.saveParam);
			await reportRender(data, 'partnerList', reportMrtUrl('partnerList'));
		},
		async reportExcel() {
			const param = objectCopy(this.saveParam);
			param.include_doc_cnt = true;
			const { data } = await apiSelectPartnerList(param);
			// await reportRender(data, 'partnerList', reportMrtUrl('partnerList'));

			let header = [
				{ key: 'code', name: 'Code', width: 15, dataType: defaultDataType.string },
				{ key: 'name', name: 'Name', width: 25, dataType: defaultDataType.string },
				{ key: 'ytd', name: 'YTD', width: 15, dataType: defaultDataType.currency },
				{ key: 'sales_group_name', name: 'Sales Group', width: 20, dataType: defaultDataType.string },
				{ key: 'sales_team_name', name: 'Sales Team', width: 20, dataType: defaultDataType.string },
				{ key: 'salesman_id', name: 'Salesman', width: 15, dataType: defaultDataType.string },
				{ key: 'last_invoice_date', name: 'Last Invoice Date', width: 15, dataType: defaultDataType.string },
				{ key: 'last_invoice_amount', name: 'Last Invoice Amount', width: 15, dataType: defaultDataType.currency },
				{ key: 'telephone', name: 'Phone 1', width: 15, dataType: defaultDataType.string },
				{ key: 'telephone2', name: 'Phone 2', width: 15, dataType: defaultDataType.string },
				{ key: 'address_detail', name: 'Address', width: 45, dataType: defaultDataType.string },
				{ key: 'address_city', name: 'City', width: 15, dataType: defaultDataType.string },
				{ key: 'address_state', name: 'state', width: 15, dataType: defaultDataType.string },
				{ key: 'address_zipcode', name: 'Zip Code', width: 15, dataType: defaultDataType.string },
				{ key: 'country', name: 'Country', width: 15, dataType: defaultDataType.string },
				{ key: 'open_date', name: 'Open Date', width: 15, dataType: defaultDataType.string },
				{ key: 'payment_term_name', name: 'Payment', width: 15, dataType: defaultDataType.string },
				{ key: 'delivery_type_name', name: 'Delivery type', width: 15, dataType: defaultDataType.string },
				{ key: 'email', name: 'Email', width: 35, dataType: defaultDataType.string },
				{ key: 'active_yn', name: 'Active', width: 10, dataType: defaultDataType.string },
				{ key: 'blocked', name: 'Blocked', width: 10, dataType: defaultDataType.string },
				{ key: 'block_reason', name: 'Block Reason', width: 40, dataType: defaultDataType.string },
				{ key: 'owner_name', name: 'Owner Name', width: 40, dataType: defaultDataType.string },
				{ key: 'doc_cnt', name: 'Count of Document', width: 20, dataType: defaultDataType.currency },
			];

			exportDataExcel(data.partnerList, header, 'Partners');
		},

		async confirmCustomerStatement(type) {
			if (!this.checkedPartner || !this.checkedPartner.length) {
				this.$toast.error('Please Select Customer First.');
				return;
			}

			this.customer_statement_type = type;
			if (['minkhair'].includes(this.company_id)) {
				this.modalName = 'customer_statement_criteria';
				this.showModal = true;
			} else {
				this.customerStatement();
			}
		},
		async customerStatement() {
			const param = objectToFormData({
				partner_codes: this.checkedPartner,
				comparison_target: this.customer_statement_type,
				date: today(),
				payment_date: this.payment_date,
				show_credit: this.show_credit,
				show_PDC: this.show_PDC,
				show_payment: this.show_payment,
			});
			const { data } = await apiSelectCustomerStatement(param);

			// reorganizeInvAndPay(data.data, this.company_id);
			// if (['newjigu'].includes(this.company_id)) combineInvAndPDC(data.data);

			const reportTemplate = await apiGetBase64ReportTemplate('customerStatement', companyMrtUrl('customerStatement'));
			let ccList = [];
			if (data.data.length === 1) {
				if (data.data[0].customer.email) ccList.push(data.data[0].customer.email);
			}
			const report = new Report(reportTemplate, data, 'CustomerStatement', PrintType.Normal, false, false, ccList);
			this.$store.commit('setReport', report);
		},
		customersWithNoRecentSalesShow() {
			this.$store.dispatch('partners/AC_CustomersWithNoRecentSalesModalShow', true);
		},
	},
	created() {
		let route = this.$route;
		if (route.query.initial_partner_type) {
			this.initial_partner_type = route.query.initial_partner_type;
		} else {
			this.initial_partner_type = route.meta.initial_partner_type;
		}

		this.$store.commit('setSideIndex', 8);

		if (this.initial_partner_type === 'C') {
			this.$store.commit('setSelectedMenu', 'nav_li_customer_main');
			this.$store.commit('setSubTitle', 'Partner -> Customer');
		} else if (this.initial_partner_type === 'V') {
			this.$store.commit('setSelectedMenu', 'nav_li_vendor_main');
			this.$store.commit('setSubTitle', 'Partner -> Vendor');
		} else {
			this.$store.commit('setSelectedMenu', 'nav_li_partner_main');
			this.$store.commit('setSubTitle', 'Partner -> Main');
		}

		this.partner_type = this.initial_partner_type;

		this.init();
	},
	mounted() {
		inputSelectOnClick();
		// makeTableResizable();
	},
};
</script>
